import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.agents')
  .filter('agentName', agentName);

function agentName() {
  return function (agent, defaultValue?) {
    const firstName = _.trim(_.get(agent, 'user.firstName') || '');
    const lastName = _.trim(_.get(agent, 'user.lastName') || '');
    const fullName = _.trim(`${firstName} ${lastName}`);

    return fullName || _.get(agent, 'externalId') || defaultValue || '—';
  }
}
